export enum VehicleProfileRoutes {
  Root = 'vehicle-profile',
  Recalls = 'vehicle-recalls',
  RecallDetail = 'recall-details',
  Mileage = 'vehicle-mileage',
}
